import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  getImpersonation,
  stopImpersonation,
} from "../../utils/impersonation";

// Always-visible reminder while an admin is previewing Node as another user.
// Rendered from NavListAuth so it survives role-guard redirects — even when
// the previewed user gets bounced off a page, the exit button stays on screen.
const ImpersonationBanner = () => {
  const impersonation = getImpersonation();
  if (!impersonation) return null;

  const { user } = impersonation;

  const exitPreview = () => {
    stopImpersonation();
    // Full reload so nothing fetched under the previewed identity lingers.
    window.location.assign("/admin/user/userManager");
  };

  return (
    // data-bottom-bar tells floating bottom-corner widgets
    // (components/Other/FeatureRequestBubble) how much of the bottom edge this
    // banner is taking up, so they can sit above it.
    <div
      data-bottom-bar="impersonation"
      className="fixed inset-x-0 bottom-0 z-40 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-400 px-4 py-2 text-sm text-slate-900 shadow-[0_-2px_8px_rgba(0,0,0,0.25)]"
    >
      <span className="inline-flex items-center gap-1.5 font-semibold">
        <VisibilityIcon sx={{ fontSize: 18 }} />
        Previewing as {user?.name}
      </span>
      <span className="hidden sm:inline">
        You're seeing Node with{" "}
        {user?.roles?.length ? `roles: ${user.roles.join(", ")}` : "no roles"}.
        Anything you submit is saved for real.
      </span>
      <button
        type="button"
        onClick={exitPreview}
        className="rounded-lg bg-slate-900 px-3 py-1 font-semibold text-white transition hover:bg-slate-700"
      >
        Exit preview
      </button>
    </div>
  );
};

export default ImpersonationBanner;
